var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activity_Icon",
    "data-name": "Activity Icon",
    transform: "translate(-272.963 -598.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95494",
    "data-name": "Path 95494",
    d: "M294.958,622.548c.369,0,.678-.005.986,0a3,3,0,0,1,.171,6c-.083.007-.167.008-.251.008-6.3,0-12.6.015-18.9-.008a3.95,3.95,0,0,1-4-4.047q-.012-12.334,0-24.667c0-.946.33-1.271,1.289-1.271q8.257,0,16.514,0a3.982,3.982,0,0,1,4.188,4.17q.006,9.509,0,19.018ZM274.97,600.567v.639q0,11.547,0,23.095a4.8,4.8,0,0,0,.014.5,1.92,1.92,0,0,0,1.983,1.7c0-.2,0-.406,0-.61.014-2.195,1.178-3.342,3.393-3.343h12.59v-.681q0-9.477,0-18.953c0-1.609-.73-2.345-2.329-2.345q-7.471,0-14.942,0Zm4,25.964c.237.011.36.021.483.021q8.124,0,16.247,0a1.835,1.835,0,0,0,.555-.065.917.917,0,0,0,.69-1,.934.934,0,0,0-.865-.921,3.838,3.838,0,0,0-.564-.011H286.3q-3.042,0-6.085,0c-.916,0-1.231.323-1.24,1.247C278.969,626.028,278.971,626.253,278.971,626.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95495",
    "data-name": "Path 95495",
    d: "M312.078,630.453c1.972,0,3.945,0,5.917,0,.785,0,1.224.363,1.235.993.012.652-.449,1.056-1.254,1.057q-5.917.008-11.835,0c-.78,0-1.219-.38-1.232-1.011-.013-.665.427-1.037,1.251-1.039Q309.119,630.448,312.078,630.453Z",
    transform: "translate(-28.051 -27.787)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95496",
    "data-name": "Path 95496",
    d: "M312.105,662.288q2.829,0,5.659,0a3.455,3.455,0,0,1,.641.029.934.934,0,0,1,.809.872.949.949,0,0,1-.651,1.06,1.583,1.583,0,0,1-.568.084q-5.948.007-11.9,0c-.769,0-1.206-.405-1.2-1.04s.444-1,1.226-1C308.118,662.283,310.112,662.288,312.105,662.288Z",
    transform: "translate(-28.043 -55.738)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95497",
    "data-name": "Path 95497",
    d: "M308.965,696.037c-.942,0-1.884.006-2.826,0-.794-.007-1.221-.358-1.235-.991-.014-.656.431-1.049,1.248-1.053q2.858-.015,5.717,0c.773.005,1.207.4,1.2,1.033s-.436,1-1.218,1.009C310.892,696.044,309.929,696.037,308.965,696.037Z",
    transform: "translate(-27.974 -83.462)",
    fill: "#ffb600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/Activity-Icon.7814f63121aadcef5a7e4e700a4978c1.svg";
export { ForwardRef as ReactComponent };